export default "__VITE_ASSET__DZWrPZmM__"